function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { spacing8, spacing16, info40, lineHeightTight } from "@churchofjesuschrist/eden-style-constants";
import { ChevronDown as ChevDown } from "@churchofjesuschrist/eden-icons";
import { Title4, Title5 } from "@churchofjesuschrist/eden-headings";
import { A11y } from "@churchofjesuschrist/eden-buttons";
const base = css(["line-height:", ";margin-inline-start:", ";"], lineHeightTight, spacing16);
const Chevron = styled(ChevDown).withConfig({
  componentId: "sc-6eduu4-0"
})(["", ";", ""], base, ({
  open
}) => open ? `transform: rotate(180deg);` : "");
const ChevronWrapper = styled.div.withConfig({
  componentId: "sc-6eduu4-1"
})(["display:flex;align-items:center;"]);
const HandleOuter = styled(A11y).withConfig({
  componentId: "sc-6eduu4-2"
})(["width:100%;align-items:center;cursor:pointer;display:flex;justify-content:space-between;padding:0 ", ";padding:", ";&:hover,&:focus{color:", ";}"], spacing8, ({
  small
}) => small ? `0 ${spacing16} ` : `0 ${spacing8}`, info40);
const Title = styled(Title4).withConfig({
  componentId: "sc-6eduu4-3"
})(["display:inline-block;margin:0;padding:", " 0;text-align:start;width:100%;"], spacing16);
const SmallTitle = styled(Title5).withConfig({
  componentId: "sc-6eduu4-4"
})(["display:inline-block;margin:0;padding:", " 0;text-align:start;width:100%;"], spacing16);

const Handle = ({
  open,
  onToggle,
  onClick,
  children,
  small,
  ...props
}) => /*#__PURE__*/React.createElement(HandleOuter, _extends({}, props, {
  "aria-expanded": open,
  onClick: event => {
    onClick && onClick(event);
    onToggle && onToggle(event);
  },
  type: "button",
  small: small
}), small ? /*#__PURE__*/React.createElement(SmallTitle, null, children) : /*#__PURE__*/React.createElement(Title, null, children), /*#__PURE__*/React.createElement(ChevronWrapper, null, /*#__PURE__*/React.createElement(Chevron, {
  open: open,
  size: "1.5rem"
})));

Handle.propTypes = {
  /** Contents rendered inside the drawer handle */
  children: PropTypes.node.isRequired,

  /** Whether drawer handle is shown as open */
  open: PropTypes.bool,

  /** Handler of what to do when toggled */
  onToggle: PropTypes.func,

  /** Handler of what to do when clicked */
  onClick: PropTypes.func,

  /** Enable small variant */
  small: PropTypes.bool
};
export default Handle;